<template>
  <div class="component forms-radio">
    <label v-if="label" v-html="label"></label>
    <div class="options" v-bind:class="{ horizontal: horizontal }">
      <v-radio-group
        v-model="newValue"
        v-bind:column="!horizontal"
        v-bind:style="radioGroupStyle"
        v-on:change="onChange"
      >
        <div
          v-for="(option, index) in options"
          class="option d-inline-block"
          v-bind:class="optionClasses(option)"
          v-bind:style="optionStyle"
        >
          <div class="option-inner">
            <template v-if="optionImage(option)">
              <label class="text-center">
                <img
                  class="d-block img-fluid"
                  v-bind:src="optionImage(option)"
                />
                {{ option.text }}
                <input
                  type="radio"
                  v-bind:name="id"
                  v-bind:id="`${id}_${index}`"
                  v-bind:key="index"
                  v-bind:label="option.text"
                  v-bind:value="option.value"
                  v-on:change="onChange"
                  v-model="newValue"
                />
              </label>
            </template>
            <template v-else="">
              <v-radio
                v-bind:name="id"
                v-bind:id="`${id}_${index}`"
                v-bind:key="index"
                v-bind:label="option.text"
                v-bind:value="option.value"
              ></v-radio>
            </template>
          </div>
        </div>
      </v-radio-group>
    </div>
  </div>
</template>

<script type="text/babel">
import _get from "lodash/get";
import { VRadio, VRadioGroup } from "vuetify/lib";

export default {
  name: "components-forms-radio-index",
  watch: {
    value() {
      this.newValue = this.value;
    }
  },
  props: {
    value: undefined,
    id: undefined,
    type: {
      default: "text"
    },
    horizontal: {
      default: false
    },
    image: {
      default: undefined
    },
    label: {
      default: undefined
    },
    options: {
      required: true
    }
  },
  data() {
    return {
      newValue: undefined
    };
  },
  methods: {
    optionImage(option) {
      let image = this.optionConfigValue("image", option);

      if (!image) {
        return;
      }

      if (
        this.optionConfigValue("image_active", option) &&
        this.optionIsActive(option)
      ) {
        image = this.optionConfigValue("image_active", option);
      }

      return image;
    },
    optionClasses(option) {
      let classes = [];

      if (this.optionIsActive(option)) {
        classes.push("active");
      }

      if (this.horizontal) {
        // classes.push('d-inline');
      }

      if (this.optionConfigValue("image", option)) {
        classes.push("with-image");
      } else {
        classes.push("without-image");
      }

      return classes;
    },
    optionIsActive(option) {
      return option.value === this.newValue;
    },
    onChange() {
      this.$emit("input", this.newValue);
    },
    optionConfigValue(key, config) {
      return _get(config, key);
    }
  },
  computed: {
    radioGroupStyle() {
      let style = {};

      return style;
    },
    optionStyle() {
      let style = {};

      if (this.horizontal) {
        style.width = `${100 / this.options.length}%`;
      }

      return style;
    }
  },
  created() {
    if (this.value === undefined) {
      this.newValue = [];
    } else {
      this.newValue = this.value;
    }
  },
  mounted() {},
  beforeDestroy() {},
  mixins: [],
  components: {
    VRadio,
    VRadioGroup
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.forms-radio {
  .label {
    top: 3px;
    position: relative;
  }

  .v-input {
    margin-top: 0px;
  }

  .v-input__slot {
    margin-bottom: 0px !important;
  }

  .v-input--selection-controls .v-input__control {
    width: 100%;
  }

  .options {
    &.horizontal {
      .option-inner {
        padding-right: 10px;
      }
    }
  }

  .option {
    &.without-image {
      label {
        top: 3px;
        position: relative;
      }
    }

    &.with-image {
      text-align: center;
      label {
        cursor: pointer;
      }

      input[type="radio"] {
        display: none;
      }

      &.active {
        font-weight: bold;
      }
    }
  }
}
</style>
